<template>
    <div id="layoutSidenav_nav">
        <nav
                class="sidebar sb-sidenav accordion sb-sidenav-dark"
                id="sidenavAccordion"
        >
            <div class="sb-sidenav-menu">
                <div class="nav">
                    <router-link
                            to="/system/activities"
                            class="nav-link"
                            v-if="$can('otpm_view_logs')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-calendar"></i>
                        </div>
                        Activity Logs
                    </router-link>
                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#miscellaneous"
                            aria-expanded="false"
                            aria-controls="miscellaneous"
                            v-if="$can('otpm_view_miscellaneous')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-list"></i>
                        </div>
                        Miscellaneous
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="miscellaneous"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    to="/system/po-type"
                                    class="nav-link"
                                    v-if="$can('otpm_view_po_types')"
                            >
                                Types
                            </router-link>
                        </nav>
                    </div>
                    
                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#material"
                            aria-expanded="false"
                            aria-controls="material"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-boxes"></i>
                        </div>
                        Material Management
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="material"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    to="/system/material-master"
                                    class="nav-link"
                            >
                                Material Master
                            </router-link>

                            <a
                                    class="nav-link collapsed"
                                    href="#"
                                    data-toggle="collapse"
                                    data-target="#stockcard_tab"
                                    aria-expanded="false"
                                    aria-controls="stockcard_tab"
                            >
                                Stock Card
                                <div class="sb-sidenav-collapse-arrow">
                                    <i class="fas fas fa-angle-down"></i>
                                </div>
                            </a>

                            <div
                                    class="collapse"
                                    id="stockcard_tab"
                                    aria-labelledby="material"
                                    data-parent="#stockcard_tab"
                            >
                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'stockcard-list' }"
                                            class="nav-link"
                                            v-if="$can('otpm_view_stockcard')"
                                    >
                                        Search Material
                                    </router-link>

                                    <router-link
                                            :to="{ name: 'stockcard-begbal' }"
                                            class="nav-link"
                                            v-if="$can('otpm_view_stockcard')"
                                    >
                                        Beginning Balance
                                    </router-link>
                                </nav>
                            </div>
                        </nav>
<!--                        <nav class="sb-sidenav-menu-nested nav">-->
<!--                            <router-link -->
<!--                                    to="/system/material-history"-->
<!--                                    class="nav-link"-->
<!--                                    v-if="$can('otpm_view_material_history')"-->
<!--                            >-->
<!--                                Material History-->
<!--                            </router-link>-->
<!--                        </nav>-->

                    </div>
                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#inventory"
                            aria-expanded="false"
                            aria-controls="inventory"
                            v-if="$can('otpm_view_inventory')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-boxes"></i>
                        </div>
                        Inventory Management
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="inventory"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    to="/system/inventory"
                                    class="nav-link"
                                    v-if="$can('otpm_view_inventory')"
                            >
                                Materials
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    to="/system/inventory-package"
                                    class="nav-link"
                                    v-if="$can('otpm_view_inventory')"  
                            >
                                Packages
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link 
                                    to="/system/material-offtake"
                                    class="nav-link"
                                    v-if="$can('otpm_view_material_offtake')"
                            >
                                Material Offtake
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    to="/system/offtake_report"
                                    class="nav-link"
                                    v-if="$can('otpm_view_offtake_report')"
                            >
                                Offtake Report
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    to="/system/inventory_monitoring/list"
                                    class="nav-link"
                                    v-if="$can('otpm_view_inventory_monitoring')"
                            >
                                Monitoring
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'inventory-ordering' }"
                                    class="nav-link"
                                    v-if="$can('otpm_view_inventory_ordering')"
                            >
                                Ordering Report
                            </router-link>
                        </nav>

                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'inventory-ordering-purchasing' }"
                                    class="nav-link"
                                    v-if="$can('otpm_view_inventory_ordering_purchasing')"
                            >
                                Purchasing Entry
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'inventory-ordering-logistics' }"
                                    class="nav-link"
                                    v-if="$can('otpm_view_inventory_ordering_logistics')"
                            >
                                Logistics Entry
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'inventory-ordering-inventory' }"
                                    class="nav-link"
                                    v-if="$can('otpm_view_inventory_ordering')"
                            >
                                Inventory Entry
                            </router-link>
                        </nav>
                    </div>
                    <a
                        class="nav-link collapsed"
                        href="#"
                        data-toggle="collapse"
                        data-target="#inventory_pvc"
                        aria-expanded="false"
                        aria-controls="inventory"
                        v-if="$can('otpm_view_inventory_pvc')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-boxes"></i>
                        </div>
                        Inventory Management - PVC
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                        class="collapse"
                        id="inventory_pvc"
                        aria-labelledby="headingOne"
                        data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                to="/system/inventory_pvc"
                                class="nav-link"
                                v-if="$can('otpm_view_inventory')"
                            >
                                Materials
                            </router-link>
                        </nav>
                    </div>
                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#purchaseOrder"
                            aria-expanded="false"
                            aria-controls="purchaseOrder"
                            v-if="$can('otpm_view_purchase_orders')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-cart-arrow-down"></i>
                        </div>
                        Purchase Order Management
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="purchaseOrder"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                    
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    to="/system/release-po"
                                    class="nav-link"
                                    v-if="$can('otpm_release_purchase_orders')"
                            >
                                For Release
                            </router-link>
                            
                            <router-link
                                    to="/system/pending-po"
                                    class="nav-link"
                                    v-if="
                  $can('otpm_approve_purchase_orders') ||
                  $can('otpm_reject_purchase_orders')
                "
                            >
                                For Approval
                            </router-link>

                            <router-link to="/system/my-purchase-orders" class="nav-link">
                                My Orders
                            </router-link>

                            <a
                                    class="nav-link collapsed"
                                    href="#"
                                    data-toggle="collapse"
                                    data-target="#purchaseOrderImportation"
                                    aria-expanded="false"
                                    aria-controls="purchaseOrderImportation"
                                    v-if="$can('otpm_view_pr_importation')"
                            >
                                PO - Importation
                                <div class="sb-sidenav-collapse-arrow">
                                    <i class="fas fa-angle-down"></i>
                                </div>
                            </a>

                            <div
                                    class="collapse"
                                    id="purchaseOrderImportation"
                                    aria-labelledby="headingOne"
                                    data-parent="#purchaseOrder"
                            >
                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            to="/system/po_importation"
                                            class="nav-link"
                                            v-if="$can('otpm_view_pr_importation')"
                                    >
                                        Purchase Requests
                                    </router-link>
                                    <router-link
                                            to="/system/po_importation_approval"
                                            class="nav-link"
                                            v-if="$can('otpm_approve_pr_imp_level_1') || $can('otpm_approve_pr_imp_level_2')"
                                    >
                                        For Approval
                                    </router-link>
                                    <router-link
                                            to="/system/po_importation_approved"
                                            class="nav-link"
                                            v-if="$can('otpm_assign_pi')"
                                    >
                                        Assign PI
                                    </router-link>
                                    <router-link
                                            to="/system/pi_list"
                                            class="nav-link"
                                            v-if="$can('otpm_view_pi_list')"
                                    >
                                        PI List
                                    </router-link>
                                </nav>
                            </div>

                            <router-link
                                    to="/system/create-po"
                                    class="nav-link"
                                    v-if="$can('otpm_create_purchase_orders')"
                            >
                                Create
                            </router-link>

                            <router-link
                                    to="/system/po_aging"
                                    class="nav-link"
                                    v-if="$can('otpm_view_po_aging')"
                            >
                                PO Aging
                            </router-link>

                            <router-link
                                    to="/system/po_open_items"
                                    class="nav-link"
                                    v-if="$can('otpm_view_po_open_items')"
                            >
                                PO Open Items
                            </router-link>

                            <router-link
                                    to="/system/po_open_items_logs"
                                    class="nav-link"
                                    v-if="$can('otpm_view_po_open_items_logs')"
                            >
                                PO Open Items Logs
                            </router-link>

                            <router-link
                                    to="/system/po_incoming_items"
                                    class="nav-link"
                                    v-if="$can('otpm_view_incoming_items')"
                            >
                                Incoming Item Report
                            </router-link>


                            <router-link
                                  v-if="$can('otpm_view_fc_po_report')"
                                    to="/system/fc_po_report"
                                    class="nav-link"
                            >
                                FC PO Report
                            </router-link>
                        </nav>
                    </div>

                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#purchaseRequest"
                            aria-expanded="false"
                            aria-controls="purchaseRequest"
                            v-if="$can('otpm_view_purchase_requests')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-cart-arrow-down"></i>
                        </div>
                        Purchase Request Management
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="purchaseRequest"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    to="/system/pending-pr"
                                    class="nav-link"
                                    v-if="
                                        $can('otpm_approve_purchase_requests') ||
                                        $can('otpm_reject_purchase_requests')
                                    "
                            >
                                Purchase Requests
                            </router-link>
                            <router-link
                                    to="/system/my-purchase-requests"
                                    class="nav-link"
                                    v-if="$can('otpm_view_my_purchase_requests')"
                            >
                                Requests
                            </router-link>
                            <router-link to="/system/pr-drafts" class="nav-link">
                                Drafts
                            </router-link>
                            <router-link to="/system/cancelled_pr_list" class="nav-link" v-if="$can('otpm_view_cancelled_pr')">
                                Cancelled PR
                            </router-link>

                            <router-link to="/system/pr_cwh_list" class="nav-link" v-if="$can('otpm_view_pr_cwh')">
                                PR to Central warehouse
                            </router-link>
<!--                            <router-link-->
<!--                                    to="/system/create-pr"-->
<!--                                    class="nav-link"-->
<!--                                    v-if="$can('otpm_create_purchase_requests')"-->
<!--                            >-->
<!--                                Create-->
<!--                            </router-link>-->
<!--                            <router-link-->
<!--                                    to="/system/manual-create-pr"-->
<!--                                    class="nav-link"-->
<!--                                    v-if="$can('otpm_create_purchase_requests')"-->
<!--                            >-->
<!--                                Create By Item-->
<!--                            </router-link>-->
                        </nav>
                    </div>
                    
                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#purchase_return"
                            aria-expanded="false"
                            aria-controls="purchase_return"
                            v-if="$can('otpm_approve_purchase_return')||$can('otpm_create_purchase_return')||$can('otpm_create_purchase_order')||$can('otpm_view_approved_purchase_return')||$can('otpm_view_purchase_return')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-undo"></i>
                        </div>
                        Purchase Return Management
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="purchase_return"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav" v-if="$can('otpm_view_approved_purchase_return')">
                            <router-link
                                    to="/system/approved-purchase-returns"
                                    class="nav-link"
                            >
                                Approved Purchase Returns
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav" v-if="$can('otpm_release_purchase_return')">
                            <router-link
                                    to="/system/for-release-purchase-returns"
                                    class="nav-link"
                            >
                                For Release
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav" v-if="$can('otpm_view_purchase_return')">
                            <router-link
                                    to="/system/purchase-returns"
                                    class="nav-link"
                            >
                                For Approval
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav" v-if="$can('otpm_view_my_purchase_return')">
                            <router-link
                                    to="/system/my-purchase-returns"
                                    class="nav-link"
                            >
                                My Purchase Returns
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav" v-if="$can('otpm_create_purchase_return')">
                            <router-link
                                    to="/system/purchase-return-draft"
                                    class="nav-link"
                            >
                                Drafts
                            </router-link>
                        </nav>
                        <nav class="sb-sidenav-menu-nested nav" v-if="$can('otpm_create_purchase_return')">
                            <router-link
                                    to="/system/purchase-return-create"
                                    class="nav-link"
                            >
                                Create
                            </router-link>
                        </nav>
                    </div>



                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#st_pr_creation"
                            aria-expanded="false"
                            aria-controls="st_pr_creation"
                            v-if="$can('otpm_approve_mngr_stock_transfer') || $can('otpm_create_stock_transfer') || $can('otpm_create_purchase_requests')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fas fa-cubes"></i>
                        </div>
                        PR / Stock Request Creation
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="st_pr_creation"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'pr-st-create' }"
                                    class="nav-link"
                            >
                                Create PR / Stock Request
                            </router-link>

                            <router-link
                                    :to="{ name: 'pr-st-drafts' }"
                                    class="nav-link"
                            >
                                Unprocessed Request
                            </router-link>

                            <router-link
                                    :to="{ name: 'supplier-recommendation' }"
                                    class="nav-link"
                                    v-if="$can('otpm_maintain_supplier_recommendation')"
                            >
                                Supplier Recommendation
                            </router-link>
                        </nav>
                    </div>


                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#stockTransfer"
                            aria-expanded="false"
                            aria-controls="stockTransfer"
                            v-if="$can('otpm_approve_mngr_stock_transfer') || $can('otpm_create_stock_transfer')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fas fa-truck"></i>
                        </div>
                        Stock Transfer
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="stockTransfer"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'reserved-stock-transfer' }"
                                    class="nav-link"
                                    v-if="$can('otpm_create_stock_transfer') || $can('otpm_approve_mngr_stock_transfer')"
                            >
                                Reserved Materials
                            </router-link>


<!--                            <router-link-->
<!--                                    :to="{ name: 'create-stock-transfer' }"-->
<!--                                    class="nav-link"-->
<!--                                    v-if="$can('otpm_create_stock_transfer') "-->
<!--                            >-->
<!--                                Create-->
<!--                            </router-link>-->


                            <router-link
                                    :to="{ name: 'on_order-stock-transfer' }"
                                    class="nav-link"
                                    v-if="$can('otpm_create_stock_transfer')"
                            >
                                On-order
                            </router-link>
                            <router-link
                                    :to="{ name: 'for_serving-stock-transfer' }"
                                    class="nav-link"
                                    v-if="$can('otpm_create_stock_transfer')"
                            >
                                For serving
                            </router-link>

                            <router-link
                                    :to="{ name: 'on_order_open_only-stock-transfer' }"
                                    class="nav-link"
                                    v-if="$can('otpm_create_stock_transfer')"
                            >
                                On-order (Open Only)
                            </router-link>
                            <router-link
                                    :to="{ name: 'for_serving_open_only-stock-transfer' }"
                                    class="nav-link"
                                    v-if="$can('otpm_create_stock_transfer')"
                            >
                                For serving (Open Only)
                            </router-link>

                            <router-link
                                    :to="{ name: 'pending_list-stock-transfer' }"
                                    class="nav-link"
                                    v-if="
                  $can('otpm_approve_mngr_stock_transfer') || $can('otpm_allow_approve_level_1_stock_transfer')
                "
                            >
                                For Approval
                            </router-link>


                            <a
                                    class="nav-link collapsed"
                                    href="#"
                                    data-toggle="collapse"
                                    data-target="#packingListSub"
                                    aria-expanded="false"
                                    aria-controls="packingListSub"
                                    v-if="$can('otpm_create_stock_transfer') || $can('otpm_approve_mngr_stock_transfer')"
                            >

                                Packing List
                                <div class="sb-sidenav-collapse-arrow">
                                    <i class="fas fas fa-angle-down"></i>
                                </div>
                            </a>

                            <div
                                    class="collapse"
                                    id="packingListSub"
                                    aria-labelledby="headingFour"
                                    data-parent="#packingListSub"
                            >

                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'approved_requests-stock-transfer' }"
                                            class="nav-link"
                                            v-if="$can('otpm_create_stock_transfer') || $can('otpm_approve_mngr_stock_transfer')"
                                    >
                                        Approved Requests
                                    </router-link>
                                </nav>

                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'approved_requests_by_material-stock-transfer' }"
                                            class="nav-link"
                                            v-if="$can('otpm_create_stock_transfer') || $can('otpm_approve_mngr_stock_transfer')"
                                    >
                                        Approved Materials
                                    </router-link>
                                </nav>



                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'view_packing_list-stock-transfer-draft' }"
                                            class="nav-link"
                                            v-if="$can('view_draft_packing_list')"
                                    >
                                        Draft PL
                                    </router-link>
                                </nav>



                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'view_packing_list-stock-transfer' }"
                                            class="nav-link"
                                            v-if="$can('otpm_create_stock_transfer')"
                                    >
                                        List
                                    </router-link>
                                </nav>
                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'packing_list-stock-transfer' }"
                                            class="nav-link"
                                            v-if="$can('otpm_create_stock_transfer') || $can('otpm_approve_mngr_stock_transfer')"
                                    >
                                        Create
                                    </router-link>
                                </nav>

                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'receive-stock-transfer' }"
                                            class="nav-link"
                                            v-if="$can('otpm_create_stock_transfer')"
                                    >
                                        Receive
                                    </router-link>
                                </nav>

                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'for_confirmation-stock-transfer' }"
                                            class="nav-link"
                                            v-if="$can('otpm_approve_mngr_stock_transfer')"
                                    >
                                        For Confirmation
                                    </router-link>
                                </nav>
                            </div>


                            <a
                                    class="nav-link collapsed"
                                    href="#"
                                    data-toggle="collapse"
                                    data-target="#storeLocTransferSub"
                                    aria-expanded="false"
                                    aria-controls="storeLocTransferSub"
                                    v-if="$can('otpm_create_stock_transfer')"
                            >
                                Storage Location Transfer
                                <div class="sb-sidenav-collapse-arrow">
                                    <i class="fas fas fa-angle-down"></i>
                                </div>
                            </a>

                            <div
                                    class="collapse"
                                    id="storeLocTransferSub"
                                    aria-labelledby="headingThree"
                                    data-parent="#storeLocTransferSub"
                            >
                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'store_loc_req-stock-transfer' }"
                                            class="nav-link"
                                    >
                                        List
                                    </router-link>
                                </nav>

                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'damage_report-stock-transfer' }"
                                            class="nav-link"
                                    >
                                        Create
                                    </router-link>
                                </nav>

                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'unprocessed_stor_loc_trans-stock-transfer' }"
                                            class="nav-link"
                                    >
                                        Unprocessed Requests
                                    </router-link>
                                </nav>

                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'for_approval_stor_loc_trans-stock-transfer' }"
                                            class="nav-link" v-if="$can('otpm_approve_stor_loc_request')"
                                    >
                                        Approve Request
                                    </router-link>
                                </nav>
                            </div>




<!--                            <router-link-->
<!--                                    :to="{ name: 'transfer_out-stock-transfer' }"-->
<!--                                    class="nav-link"-->
<!--                                    v-if="$can('otpm_create_stock_transfer')"-->
<!--                            >-->
<!--                                Transfer Out-->
<!--                            </router-link>-->

                            <a
                                    class="nav-link collapsed"
                                    href="#"
                                    data-toggle="collapse"
                                    data-target="#transferOutSub"
                                    aria-expanded="false"
                                    aria-controls="transferOutSub"
                                    v-if="$can('otpm_create_stock_transfer')"
                            >
                                Transfer Out
                                <div class="sb-sidenav-collapse-arrow">
                                    <i class="fas fas fa-angle-down"></i>
                                </div>
                            </a>

                            <div
                                    class="collapse"
                                    id="transferOutSub"
                                    aria-labelledby="headingThree"
                                    data-parent="#transferOutSub"
                            >
                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'transfer_out-stock-transfer' }"
                                            class="nav-link"
                                    >
                                        Create
                                    </router-link>
                                </nav>

                                <nav class="sb-sidenav-menu-nested nav">
                                    <router-link
                                            :to="{ name: 'unprocessed_transfer_out-stock-transfer' }"
                                            class="nav-link"
                                    >Unprocessed Requests

                                    </router-link>
                                </nav>
                            </div>

                            <router-link
                                    :to="{ name: 'history-stock-transfer' }"
                                    class="nav-link"
                                    v-if="$can('otpm_approve_mngr_stock_transfer') || $can('otpm_create_stock_transfer')"
                            >
                                Transaction History
                            </router-link>

                            <router-link
                                    :to="{ name: 'request_history-stock-transfer' }"
                                    class="nav-link"
                                    v-if="$can('otpm_approve_mngr_stock_transfer') || $can('otpm_create_stock_transfer')"
                            >
                                Request History
                            </router-link>
                        </nav>
                    </div>
                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#goodsReceiptMgmt"
                            aria-expanded="false"
                            aria-controls="goodsReceiptMgmt"
                            v-if="$can('otpm_mngr_goods_receipt') || $can('otpm_inventorist_goods_receipt')
                             || $can('otpm_goods_receipt_list_of_PO')  || $can('otpm_goods_receipt_receiving_reports')
"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fas fa-box"></i>
                        </div>
                        Goods Receipt Management
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="goodsReceiptMgmt"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'goods-receipt-list' }"
                                    class="nav-link"
                                    v-if="$can('otpm_goods_receipt_list_of_PO')"
                            >
                                List of Purchase Order
                            </router-link>
                        </nav>

                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'goods-receipt-receiving-report' }"
                                    class="nav-link"
                                    v-if="$can('otpm_goods_receipt_receiving_reports')"
                            >
                                Receiving Report
                            </router-link>
                        </nav>


                        <nav class="sb-sidenav-menu-nested nav">
                          <a
                              class="nav-link collapsed"
                              href="#"
                              data-toggle="collapse"
                              data-target="#goodsReceiptMgmtDR"
                              aria-expanded="false"
                              aria-controls="goodsReceiptMgmtDR"
                              v-if="$can('otpm_delivery_receipt')"
                          >
                            Delivery Receipt
                            <div class="sb-sidenav-collapse-arrow">
                              <i class="fas fas fa-angle-down"></i>
                            </div>
                          </a>



                          <div
                              class="collapse"
                              id="goodsReceiptMgmtDR"
                              aria-labelledby="headingOne"
                              data-parent="#goodsReceiptMgmtDR"
                          >
                            <nav class="sb-sidenav-menu-nested nav">
                              <router-link
                                  :to="{ name: 'dr-list' }"
                                  class="nav-link"
                                  v-if="$can('otpm_assign_dr')"
                              >
                                List of DR
                              </router-link>
                            </nav>

                            <nav class="sb-sidenav-menu-nested nav">
                              <router-link
                                  :to="{ name: 'assign-dr-create' }"
                                  class="nav-link"
                                  v-if="$can('otpm_assign_dr')"
                              >
                                Assign DR
                              </router-link>
                            </nav>
                          </div>
                        </nav>


                    </div>

                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#goodsIssueMgmt"
                            aria-expanded="false"
                            aria-controls="goodsIssueMgmt"
                            v-if="$can('otpm_mngr_goods_issue') || $can('otpm_inventorist_goods_issue')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fas fa-boxes"></i>
                        </div>
                        Goods Issue Management
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="goodsIssueMgmt"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'create-goods-issue' }"
                                    class="nav-link"
                            >
                                Create New Document
                            </router-link>
                        </nav>

                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'goods-issue-list' }"
                                    class="nav-link"
                            >
                                List of Goods Issue
                            </router-link>
                        </nav>
                    </div>

                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#truckingReport"
                            aria-expanded="false"
                            aria-controls="truckingReport"
                            v-if="$can('otpm_trucking')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fas fa-ship"></i>
                        </div>
                        Trucking Report
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fas fa-angle-down"></i>
                        </div>
                    </a>

                    <div
                            class="collapse"
                            id="truckingReport"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'create-trucking-report' }"
                                    class="nav-link"
                            >
                                Create
                            </router-link>
                        </nav>

                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'trucking-report-list' }"
                                    class="nav-link"
                            >
                                List
                            </router-link>
                        </nav>

                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    :to="{ name: 'truck-maintenance' }"
                                    class="nav-link"
                            >
                                Truck Types
                            </router-link>
                        </nav>
                    </div>



<!--                    <a-->
<!--                            class="nav-link collapsed"-->
<!--                            href="#"-->
<!--                            data-toggle="collapse"-->
<!--                            data-target="#stockcard_tab"-->
<!--                            aria-expanded="false"-->
<!--                            aria-controls="stockcard_tab"-->
<!--                    >-->
<!--                        <div class="sb-nav-link-icon">-->
<!--                            <i class="fas fas fa-book"></i>-->
<!--                        </div>-->
<!--                        Stock Card-->
<!--                        <div class="sb-sidenav-collapse-arrow">-->
<!--                            <i class="fas fas fa-angle-down"></i>-->
<!--                        </div>-->
<!--                    </a>-->

<!--                    <div-->
<!--                            class="collapse"-->
<!--                            id="stockcard_tab"-->
<!--                            aria-labelledby="headingOne"-->
<!--                            data-parent="#sidenavAccordion"-->
<!--                    >-->
<!--                        <nav class="sb-sidenav-menu-nested nav">-->
<!--                            <router-link-->
<!--                                    :to="{ name: 'stockcard-list' }"-->
<!--                                    class="nav-link"-->
<!--                                    v-if="$can('otpm_view_stockcard')"-->
<!--                            >-->
<!--                                Search Material-->
<!--                            </router-link>-->

<!--                            <router-link-->
<!--                                    :to="{ name: 'stockcard-begbal' }"-->
<!--                                    class="nav-link"-->
<!--                                    v-if="$can('otpm_view_stockcard')"-->
<!--                            >-->
<!--                                Beginning Balance-->
<!--                            </router-link>-->
<!--                        </nav>-->
<!--                    </div>-->


                    <a
                            class="nav-link collapsed"
                            href="#"
                            data-toggle="collapse"
                            data-target="#userManagement"
                            aria-expanded="false"
                            aria-controls="userManagement"
                            v-if="
              $can('otpm_view_permission') ||
              $can('otpm_view_role') ||
              $can('otpm_view_user')
            "
                    >
                        <div class="sb-nav-link-icon">
                            <i class="nav-icon fas fa-users"></i>
                        </div>
                        User Management
                        <div class="sb-sidenav-collapse-arrow">
                            <i class="fas fa-angle-down"></i>
                        </div>
                    </a>
                    <div
                            class="collapse"
                            id="userManagement"
                            aria-labelledby="headingOne"
                            data-parent="#sidenavAccordion"
                    >
                        <nav class="sb-sidenav-menu-nested nav">
                            <router-link
                                    to="/system/permission"
                                    class="nav-link"
                                    v-if="$can('otpm_view_permission')"
                            >Permissions
                            </router-link>
                            <router-link
                                    to="/system/role"
                                    v-if="$can('otpm_view_role')"
                                    class="nav-link"
                            >Roles
                            </router-link>
                            <router-link
                                    to="/system/user"
                                    v-if="$can('otpm_view_user')"
                                    class="nav-link"
                            >Users
                            </router-link>
                            <router-link
                                    to="/system/user-supplier"
                                    v-if="$can('otpm_view_user')"
                                    class="nav-link"
                            >User Supplier
                            </router-link>
                            <router-link
                                    to="/system/user-approver"
                                    v-if="$can('otpm_view_user')"
                                    class="nav-link"
                            >User Approver
                            </router-link>
                            <router-link
                                    to="/system/assign_rel_code"
                                    v-if="$can('otpm_view_user')"
                                    class="nav-link"
                            >Rel Code Assignment
                            </router-link>

                            <router-link
                                    to="/system/notifications"
                                    v-if="$can('otpm_view_notifications')"
                                    class="nav-link"
                            >Email Notifications
                            </router-link>

                            <router-link
                                to="/system/approval_maintenance"
                                v-if="$can('otpm_view_approval_maintenance')"
                                class="nav-link"
                            >Approval Maintenance
                            </router-link>
                        </nav>
                    </div>

                    <router-link
                            :to="{ name: 'po-config' }"
                            class="nav-link"
                            v-if="$can('otpm_po_config')"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-coins"></i>
                        </div>
                        PO Configuration
                    </router-link>

                    <router-link
                            :to="{ name: 'change-logs' }"
                            class="nav-link"
                    >
                        <div class="sb-nav-link-icon">
                            <i class="fas fa-highlighter"></i>
                        </div>
                        Change Logs
                    </router-link>


                    <a class="nav-link" href="/log-viewer" target="_blank" v-if="$can('otpm_view_logs')">
                        <div class="sb-nav-link-icon">
                            <i class="nav-icon fas fa-cog"></i>
                        </div>
                        System Logs</a>
                </div>
            </div>
            <div class="sb-sidenav-footer">
                <div class="small">Logged in as:</div>
                {{ profileName }}
            </div>
        </nav>
    </div>
</template>
<script>
    import * as authService from "../services/auth.js";

    export default {
        name: "sidebar",
        computed: {
            profileName() {
                if (this.$store.getters.currentUser === null) {
                    return null;
                }
                return this.$store.getters.currentUser.user.name
            },

            // currentUser() {
            //     return this.$store.getters.currentUser.user.name
            // }
        },
    };
</script>